<div class="splash" flexLayout="column" fxLayoutAlign="center center" *ngIf="splashService?.isShown">
	<ng-content></ng-content>
</div>
